import React, { Component } from 'react';
import {
    Dialog, DialogContent, DialogActions, Button, Grid, TextField,
    Typography, Divider, Checkbox, FormControlLabel, CircularProgress,
    IconButton
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import * as adminProductService from '../../services/admin-product.service';

const initialState = {
    ppId: '',
    planId: '',
    periodicityId: '',
    billingModeId: '',
    planValuePerMonth: '',
    planValue: '',
    agentLimitQuantity: '',
    diskLimitUsage: '',
    diskOverageValue: '',
    attendanceLimitPerMonth: '',
    attendanceValue: '',
    additionalValueAgent: '',
    creditAmountMonthly: '',
    creditAlertThreshold: '',
    creditAutoRechargeEnabled: false,
    creditAutoRechargeAmount: '',
    creditAutoRechargeTrigger: '',
    saving: false,
};

class PlanPeriodicityDialog extends Component {
    constructor(props) {
        super(props);
        this.state = { ...initialState };
    }

    componentDidUpdate(prevProps) {
        if (this.props.open && !prevProps.open) {
            this.initForm();
        }
    }

    initForm() {
        const { planPeriodicity } = this.props;
        if (planPeriodicity) {
            this.setState({
                ...initialState,
                ppId: String(planPeriodicity.id ?? planPeriodicity.Id ?? ''),
                planId: planPeriodicity.planid ?? planPeriodicity.planId ?? '',
                periodicityId: planPeriodicity.periodicityid ?? planPeriodicity.periodicityId ?? '',
                billingModeId: this.resolveBillingModeId(planPeriodicity.billingmode ?? planPeriodicity.billingMode ?? 'unit'),
                planValuePerMonth: planPeriodicity.planvaluepermonth ?? planPeriodicity.planValuePerMonth ?? '',
                planValue: planPeriodicity.planvalue ?? planPeriodicity.planValue ?? '',
                agentLimitQuantity: planPeriodicity.agentlimitquantity ?? planPeriodicity.agentLimitQuantity ?? '',
                diskLimitUsage: planPeriodicity.disklimitusage ?? planPeriodicity.diskLimitUsage ?? '',
                diskOverageValue: planPeriodicity.diskoveragevalue ?? planPeriodicity.diskOverageValue ?? '',
                attendanceLimitPerMonth: planPeriodicity.attendancelimitpermonth ?? planPeriodicity.attendanceLimitPerMonth ?? '',
                attendanceValue: planPeriodicity.attendancevalue ?? planPeriodicity.attendanceValue ?? '',
                additionalValueAgent: planPeriodicity.additionalvalueagent ?? planPeriodicity.additionalValueAgent ?? '',
                creditAmountMonthly: planPeriodicity.creditamountmonthly ?? planPeriodicity.creditAmountMonthly ?? '',
                creditAlertThreshold: planPeriodicity.creditalertthreshold ?? planPeriodicity.creditAlertThreshold ?? '',
                creditAutoRechargeEnabled: planPeriodicity.creditautorechargeenabled ?? planPeriodicity.creditAutoRechargeEnabled ?? false,
                creditAutoRechargeAmount: planPeriodicity.creditautorechargeamount ?? planPeriodicity.creditAutoRechargeAmount ?? '',
                creditAutoRechargeTrigger: planPeriodicity.creditautorechargetrigger ?? planPeriodicity.creditAutoRechargeTrigger ?? '',
            });
        } else {
            this.setState({ ...initialState });
            adminProductService.getNextPlanPeriodicityId()
                .then(result => {
                    if (result.data.success) {
                        const nextId = result.data.data?.nextid ?? result.data.data?.NextId ?? result.data.data?.nextId ?? '';
                        this.setState({ ppId: String(nextId) });
                    }
                })
                .catch(() => {});
        }
    }

    handleChange = (field) => (e) => {
        this.setState({ [field]: e.target.value });
    }

    handleCheckbox = (field) => (e) => {
        this.setState({ [field]: e.target.checked });
    }

    handleSave = async () => {
        const { planPeriodicity, applicationId, onSave } = this.props;
        const isEdit = planPeriodicity != null;

        this.setState({ saving: true });

        const selectedMode = this.getSelectedBillingMode();
        if (!selectedMode && !this.state.billingModeId) {
            return; // billing mode obrigatório
        }
        const data = {
            billingMode: selectedMode ? selectedMode.code : 'unit',
            planValuePerMonth: parseFloat(this.state.planValuePerMonth) || 0,
            planValue: parseFloat(this.state.planValue) || 0,
            agentLimitQuantity: parseInt(this.state.agentLimitQuantity) || 0,
            diskLimitUsage: parseInt(this.state.diskLimitUsage) || 0,
            diskOverageValue: parseFloat(this.state.diskOverageValue) || 0,
            attendanceLimitPerMonth: parseInt(this.state.attendanceLimitPerMonth) || 0,
            attendanceValue: parseFloat(this.state.attendanceValue) || 0,
            additionalValueAgent: parseFloat(this.state.additionalValueAgent) || 0,
            creditAmountMonthly: parseFloat(this.state.creditAmountMonthly) || 0,
            creditAlertThreshold: parseFloat(this.state.creditAlertThreshold) || 0,
            creditAutoRechargeEnabled: this.state.creditAutoRechargeEnabled,
            creditAutoRechargeAmount: parseFloat(this.state.creditAutoRechargeAmount) || 0,
            creditAutoRechargeTrigger: parseFloat(this.state.creditAutoRechargeTrigger) || 0,
        };

        if (isEdit) {
            data.id = planPeriodicity.id;
        } else {
            data.id = Number(this.state.ppId);
            data.planId = Number(this.state.planId);
            data.periodicityId = Number(this.state.periodicityId);
            data.applicationId = applicationId;
        }

        try {
            await onSave(data);
        } finally {
            this.setState({ saving: false });
        }
    }

    resolveBillingModeId(codeOrId) {
        const { billingModes } = this.props;
        if (!billingModes) return '';
        if (typeof codeOrId === 'number') return codeOrId;
        const found = billingModes.find(b => b.code === codeOrId);
        return found ? found.id : '';
    }

    getSelectedBillingMode() {
        const { billingModes } = this.props;
        if (!billingModes || !this.state.billingModeId) return null;
        return billingModes.find(b => b.id === Number(this.state.billingModeId));
    }

    isCreditMode() {
        const mode = this.getSelectedBillingMode();
        return mode && mode.code === 'credit';
    }

    getFilteredBillingModes() {
        const { billingModes, allowedBillingModes } = this.props;
        if (!billingModes) return [];
        if (!allowedBillingModes || allowedBillingModes.length === 0) return billingModes;
        return billingModes.filter(b => allowedBillingModes.includes(b.id));
    }

    render() {
        const { open, onClose, planPeriodicity, applicationName, plans, periodicities, intl } = this.props;
        const { saving } = this.state;
        const isEdit = planPeriodicity != null;
        const headerColor = '#8BC34A';
        const filteredBillingModes = this.getFilteredBillingModes();
        const showCreditFields = this.isCreditMode();

        const fmt = (id, fallback) => {
            if (intl && intl.formatMessage) {
                try { return intl.formatMessage({ id }); } catch (e) { /* fallback */ }
            }
            return fallback || id;
        };

        return (
            <Dialog
                open={open}
                onClose={onClose}
                maxWidth="md"
                fullWidth
                PaperProps={{
                    style: { borderRadius: 12, overflow: 'hidden', maxHeight: '90vh' }
                }}
            >
                {/* Header */}
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '20px 24px 12px',
                    borderBottom: `3px solid ${headerColor}`,
                }}>
                    <div>
                        <Typography variant="h6" style={{ fontWeight: 600, fontSize: 18, color: headerColor }}>
                            {isEdit
                                ? fmt('admin.pp.edit.title', 'Editar Plan Periodicity')
                                : fmt('admin.pp.create.title', 'Adicionar Plan Periodicity')
                            }
                        </Typography>
                        {applicationName && (
                            <Typography variant="body2" style={{ color: '#757575', marginTop: 2 }}>
                                {applicationName}
                            </Typography>
                        )}
                    </div>
                    <IconButton size="small" onClick={onClose} style={{ color: '#9e9e9e' }}>
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </div>

                {/* Content */}
                <DialogContent style={{ overflowY: 'auto', maxHeight: '70vh', paddingRight: 8 }}>
                    <Grid container spacing={2} style={{ marginTop: 4 }}>
                        {/* ID, Plano e Periodicidade - somente em criacao */}
                        {!isEdit && (
                            <>
                                <Grid item xs={12} sm={3}>
                                    <TextField
                                        fullWidth variant="outlined" size="small"
                                        label="ID"
                                        type="number"
                                        value={this.state.ppId}
                                        onChange={this.handleChange('ppId')}
                                        inputProps={{ min: '1' }}
                                        required
                                        error={!this.state.ppId}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <TextField
                                        select
                                        fullWidth
                                        variant="outlined"
                                        size="small"
                                        label={fmt('admin.subscription.plan', 'Plano')}
                                        value={this.state.planId}
                                        onChange={this.handleChange('planId')}
                                        SelectProps={{ native: true }}
                                        InputLabelProps={{ shrink: true }}
                                    >
                                        <option value="">Selecione...</option>
                                        {(plans || []).map(p => (
                                            <option key={p.id ?? p.Id} value={p.id ?? p.Id}>{p.name ?? p.Name ?? p.planname ?? p.planName ?? p.PlanName ?? '-'}</option>
                                        ))}
                                    </TextField>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        select
                                        fullWidth
                                        variant="outlined"
                                        size="small"
                                        label={fmt('subscription.periodicity', 'Periodicidade')}
                                        value={this.state.periodicityId}
                                        onChange={this.handleChange('periodicityId')}
                                        SelectProps={{ native: true }}
                                        InputLabelProps={{ shrink: true }}
                                    >
                                        <option value="">Selecione...</option>
                                        {(periodicities || []).map(p => (
                                            <option key={p.id ?? p.Id} value={p.id ?? p.Id}>{p.name ?? p.Name ?? '-'}</option>
                                        ))}
                                    </TextField>
                                </Grid>
                            </>
                        )}

                        {/* ID - readonly em edição */}
                        {isEdit && (
                            <Grid item xs={12} sm={3}>
                                <TextField
                                    fullWidth variant="outlined" size="small"
                                    label="ID"
                                    value={this.state.ppId}
                                    disabled
                                    InputProps={{ style: { backgroundColor: '#ebebeb', color: '#777' } }}
                                />
                            </Grid>
                        )}

                        {/* Billing Mode */}
                        <Grid item xs={12} sm={4}>
                            <TextField
                                select
                                fullWidth
                                variant="outlined"
                                size="small"
                                label={fmt('admin.pp.billing.mode', 'Modo de Cobranca')}
                                value={this.state.billingModeId}
                                onChange={this.handleChange('billingModeId')}
                                SelectProps={{ native: true }}
                                InputLabelProps={{ shrink: true }}
                                required
                                error={!this.state.billingModeId}
                                helperText={!this.state.billingModeId ? 'Obrigatório' : ''}
                            >
                                <option value="">Selecione...</option>
                                {filteredBillingModes.map(b => (
                                    <option key={b.id ?? b.Id} value={b.id ?? b.Id}>{b.name ?? b.Name ?? b.code ?? '-'}</option>
                                ))}
                            </TextField>
                        </Grid>

                        {/* Valor Mensal */}
                        <Grid item xs={12} sm={4}>
                            <TextField
                                fullWidth
                                variant="outlined"
                                size="small"
                                type="number"
                                label={fmt('admin.subscription.price', 'Valor Mensal')}
                                value={this.state.planValuePerMonth}
                                onChange={this.handleChange('planValuePerMonth')}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ step: '0.01', min: '0' }}
                            />
                        </Grid>

                        {/* Valor Anual */}
                        <Grid item xs={12} sm={4}>
                            <TextField
                                fullWidth
                                variant="outlined"
                                size="small"
                                type="number"
                                label={fmt('admin.subscription.plan.value', 'Valor Anual')}
                                value={this.state.planValue}
                                onChange={this.handleChange('planValue')}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ step: '0.01', min: '0' }}
                            />
                        </Grid>

                        {/* Limite Agentes */}
                        <Grid item xs={12} sm={4}>
                            <TextField
                                fullWidth
                                variant="outlined"
                                size="small"
                                type="number"
                                label={fmt('admin.subscription.agents', 'Agentes')}
                                value={this.state.agentLimitQuantity}
                                onChange={this.handleChange('agentLimitQuantity')}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ min: '0' }}
                            />
                        </Grid>

                        {/* Limite Disco */}
                        <Grid item xs={12} sm={4}>
                            <TextField
                                fullWidth
                                variant="outlined"
                                size="small"
                                type="number"
                                label={fmt('admin.subscription.disk', 'Disco (MB)')}
                                value={this.state.diskLimitUsage}
                                onChange={this.handleChange('diskLimitUsage')}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ min: '0' }}
                            />
                        </Grid>

                        {/* Valor Disco Excedente */}
                        <Grid item xs={12} sm={4}>
                            <TextField
                                fullWidth
                                variant="outlined"
                                size="small"
                                type="number"
                                label={fmt('admin.pp.disk.overage.value', 'Valor Disco Excedente')}
                                value={this.state.diskOverageValue}
                                onChange={this.handleChange('diskOverageValue')}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ step: '0.01', min: '0' }}
                            />
                        </Grid>

                        {/* Limite Atendimentos/Mes */}
                        <Grid item xs={12} sm={4}>
                            <TextField
                                fullWidth
                                variant="outlined"
                                size="small"
                                type="number"
                                label={fmt('admin.subscription.attendances', 'Atendimentos/Mes')}
                                value={this.state.attendanceLimitPerMonth}
                                onChange={this.handleChange('attendanceLimitPerMonth')}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ min: '0' }}
                            />
                        </Grid>

                        {/* Valor Unitario Atendimento */}
                        <Grid item xs={12} sm={4}>
                            <TextField
                                fullWidth
                                variant="outlined"
                                size="small"
                                type="number"
                                label={fmt('admin.subscription.attendance.value', 'Valor Unitario Atendimento')}
                                value={this.state.attendanceValue}
                                onChange={this.handleChange('attendanceValue')}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ step: '0.01', min: '0' }}
                            />
                        </Grid>

                        {/* Valor Agente Adicional */}
                        <Grid item xs={12} sm={4}>
                            <TextField
                                fullWidth
                                variant="outlined"
                                size="small"
                                type="number"
                                label={fmt('admin.subscription.additional.agent', 'Valor Agente Adicional')}
                                value={this.state.additionalValueAgent}
                                onChange={this.handleChange('additionalValueAgent')}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ step: '0.01', min: '0' }}
                            />
                        </Grid>

                        {/* Secao de Creditos - condicional */}
                        {showCreditFields && (
                            <>
                                <Grid item xs={12}>
                                    <Divider style={{ marginTop: 8, marginBottom: 4 }} />
                                    <Typography variant="subtitle2" style={{
                                        fontWeight: 600,
                                        color: '#555',
                                        marginTop: 8,
                                        marginBottom: 4,
                                    }}>
                                        {fmt('admin.pp.credit.section', 'Configuracao de Creditos')}
                                    </Typography>
                                </Grid>

                                {/* Credito Mensal */}
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        size="small"
                                        type="number"
                                        label={fmt('admin.pp.credit.monthly', 'Credito Mensal (R$)')}
                                        value={this.state.creditAmountMonthly}
                                        onChange={this.handleChange('creditAmountMonthly')}
                                        InputLabelProps={{ shrink: true }}
                                        inputProps={{ step: '0.01', min: '0' }}
                                    />
                                </Grid>

                                {/* Alerta Threshold */}
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        size="small"
                                        type="number"
                                        label={fmt('admin.pp.credit.alert', 'Alerta Threshold (R$)')}
                                        value={this.state.creditAlertThreshold}
                                        onChange={this.handleChange('creditAlertThreshold')}
                                        InputLabelProps={{ shrink: true }}
                                        inputProps={{ step: '0.01', min: '0' }}
                                    />
                                </Grid>

                                {/* Recarga Automatica */}
                                <Grid item xs={12} sm={4} style={{ display: 'flex', alignItems: 'center' }}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={this.state.creditAutoRechargeEnabled}
                                                onChange={this.handleCheckbox('creditAutoRechargeEnabled')}
                                                style={{ color: '#8BC34A' }}
                                            />
                                        }
                                        label={fmt('admin.pp.credit.auto.recharge', 'Recarga Automatica')}
                                    />
                                </Grid>

                                {/* Valor Recarga */}
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        size="small"
                                        type="number"
                                        label={fmt('admin.pp.credit.recharge.amount', 'Valor Recarga (R$)')}
                                        value={this.state.creditAutoRechargeAmount}
                                        onChange={this.handleChange('creditAutoRechargeAmount')}
                                        disabled={!this.state.creditAutoRechargeEnabled}
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{
                                            style: !this.state.creditAutoRechargeEnabled
                                                ? { backgroundColor: '#ebebeb', color: '#777' }
                                                : {}
                                        }}
                                        inputProps={{ step: '0.01', min: '0' }}
                                    />
                                </Grid>

                                {/* Recarregar quando <= */}
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        size="small"
                                        type="number"
                                        label={fmt('admin.pp.credit.recharge.trigger', 'Recarregar quando <= (R$)')}
                                        value={this.state.creditAutoRechargeTrigger}
                                        onChange={this.handleChange('creditAutoRechargeTrigger')}
                                        disabled={!this.state.creditAutoRechargeEnabled}
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{
                                            style: !this.state.creditAutoRechargeEnabled
                                                ? { backgroundColor: '#ebebeb', color: '#777' }
                                                : {}
                                        }}
                                        inputProps={{ step: '0.01', min: '0' }}
                                    />
                                </Grid>
                            </>
                        )}
                    </Grid>
                </DialogContent>

                {/* Footer */}
                <div style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    gap: 8,
                    padding: '12px 24px 16px',
                    backgroundColor: '#f5f5f5',
                    borderTop: '1px solid #e0e0e0',
                }}>
                    <Button
                        onClick={onClose}
                        disabled={saving}
                        style={{ textTransform: 'none', fontWeight: 500, padding: '8px 24px' }}
                    >
                        {fmt('close', 'Fechar')}
                    </Button>
                    <Button
                        onClick={this.handleSave}
                        variant="contained"
                        disabled={saving || !this.state.billingModeId}
                        style={{
                            backgroundColor: (saving || !this.state.billingModeId) ? undefined : headerColor,
                            color: saving ? undefined : '#fff',
                            textTransform: 'none',
                            fontWeight: 600,
                            padding: '8px 28px',
                            borderRadius: 6,
                            boxShadow: saving ? 'none' : '0 2px 8px rgba(0,0,0,0.15)',
                            minWidth: 120,
                        }}
                    >
                        {saving ? (
                            <CircularProgress size={22} style={{ color: '#fff' }} />
                        ) : (
                            fmt('confirm', 'Salvar')
                        )}
                    </Button>
                </div>
            </Dialog>
        );
    }
}

export default PlanPeriodicityDialog;
